"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { GlobalError } from "@/components/shared/GlobalError";

export default function ErrorHandle({ error, reset }: { error: string; reset: () => void }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <GlobalError onRetry={reset} />;
}
